<ng-container *transloco="let t">
  @for (review of reviews; track review; let isFirst = $first) {
    <article
      class="group relative flex snap-start flex-col"
      (mouseover)="mouseOver.emit(review.reviewCode)"
      (mouseout)="mouseOut.emit(review.reviewCode)"
    >
      @if (review.trixel) {
        <rma-trixel [trixelImgUrl]="review.trixel" [trixelSourceCategory]="trixelSourceCategory" [trixelInteraction]="'ListView'" />
      }
      @if (!hideImage) {
        <div class="absolute right-4 top-4 flex items-center justify-center rounded-md bg-white px-3 py-1 text-sm capitalize">
          {{ t('reviewer-type.' + review.reviewerType | lowercase) }} {{ t('review', { reviewsCount: 1 }) }}
        </div>
        @if (review.coverImage; as coverImage) {
          @if (isFirst && !lazyLoadFirst) {
            <img
              class="mb-3 h-64 w-full rounded-lg object-cover object-center"
              [alt]="review.title"
              [src]="coverImage | imageOptimise: 'RmaImageCacheSizeTile'"
            />
          } @else {
            <img
              class="mb-3 h-64 w-full rounded-lg object-cover object-center"
              [src]="defaultImageUrl | staticImageUrl"
              [alt]="review.title"
              [lazyLoad]="coverImage | imageOptimise: 'RmaImageCacheSizeTile'"
            />
          }
        } @else {
          <img
            class="mb-3 h-64 w-full rounded-lg object-cover object-center"
            [src]="defaultImageUrl | staticImageUrl"
            [alt]="review.title"
          />
        }
      }
      <div class="space-y-3">
        <div class="flex justify-between">
          <rma-star-rating [overallStars]="review.rating" />
          @if (review.submittedOn; as date) {
            <div class="text-steel-70">
              {{ date | timeAgo }}
            </div>
          }
        </div>
        @if (review.legacyReviewUrl) {
          @if (useHref) {
            <a
              class="text-steel-100 tile-link"
              [href]="review.legacyReviewUrl"
              [ariaLabel]="review.title"
              target="_blank"
              data-id="view-full-review"
            >
              <div class="font-bold group-hover:text-blue-100" [innerHTML]="review.title"></div
            ></a>
          } @else {
            <a
              class="text-steel-100 tile-link"
              [routerLink]="review.legacyReviewUrl"
              [queryParams]="{ profileType, profileCode }"
              [ariaLabel]="review.title"
              [target]="newTab ? '_blank' : '_self'"
              data-id="view-full-review"
            >
              <div class="font-bold group-hover:text-blue-100" [innerHTML]="review.title"></div>
            </a>
          }
        }

        <p class="line-clamp-5 select-none text-steel-80" [innerHTML]="review.body"></p>
        @if (profileType !== 'Team') {
          @for (profile of review.profiles; track profile) {
            @if (profileType !== 'Individual' && profile.isPrimary) {
              <rma-profile-summary
                class="mt-2"
                [profileType]="profileType"
                [profileUrl]="profile.profileUrl"
                [avatar]="profile.avatarUrl"
                [name]="profile.profileName"
                [ratingValue]="profile.overallStars"
                [reviewCount]="profile.totalReviews"
              />
            }
          }
        } @else {
          <rma-avatar-stack class="relative z-10 block" [profiles]="review.profiles" [max]="6" displayProfileTypes="Individual" />
        }
      </div>
    </article>
  }
</ng-container>
